var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Drops-filters"},[_c('WrldSelectableFilters',{attrs:{"wrld":{index: 'Quotes', pageSize: 20},"arrFilters":_vm.WrldSelectablearrFilters}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }